import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isToken: null,
  chatType: null
};

const tokenSlice = createSlice({
  name: 'roomId',
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.isToken = action.payload.isToken;
      state.chatType = action.payload.chatType;
    },
    clearToken: (state) => {
      state.isToken = null;
      state.chatType = null;
    },
  },
});

export const { setToken, clearToken } = tokenSlice.actions;

export default tokenSlice.reducer;
